import { LocalStorage } from 'quasar'
import { digitGroup } from 'src/helpers'

export const koinworksLimit1 = 50e6
export const koinworksLimit2 = 300e6
export const koinworksLimit3 = 500e6

export const businessGrade = {
  BT: {
    name: 'Bisnis Tunai',
    badgeClass: 'custom-badge-square custom-badge-red',
    keyPoints: ['Harga Bisnis', 'Pembayaran hanya tunai']
  },
  C2: {
    name: 'Bisnis C2',
    badgeClass: 'custom-badge-square custom-badge-yellow',
    keyPoints: ['Harga Bisnis', 'Limit mencapai 5 Juta', 'Tenor 30 hari'],
    maxTerminDay: 30,
    limit: {
      min: 1,
      max: 5_000_000
    }
  },
  C1: {
    name: 'Bisnis C1',
    badgeClass: 'custom-badge-square custom-badge-purple',
    keyPoints: ['Harga Bisnis', 'Limit mencapai 100 Juta', 'Tenor 30 dan 60 hari'],
    maxTerminDay: 60,
    limit: {
      min: 5_000_001,
      max: 100_000_000
    }
  },
  BB: {
    name: 'Bisnis B',
    badgeClass: 'custom-badge-square custom-badge-blue',
    keyPoints: ['Harga Bisnis', 'Limit mencapai 2 Milyar', 'Tenor 30, 60, dan 90 hari'],
    maxTerminDay: 365,
    limit: {
      min: 100_000_001,
      max: 2_000_000_000
    }
  },
  BA: {
    name: 'Bisnis A',
    badgeClass: 'custom-badge-square custom-badge-green',
    keyPoints: ['Harga Bisnis', 'Limit Tidak Terbatas*', 'Tenor 30, 60, dan 90 hari'],
    maxTerminDay: 365,
    limit: {
      min: 2_000_000_001,
      max: Infinity
    }
  },
  KOINWORKS: {
    name: 'KoinWorks',
    badgeClass: 'custom-badge-square custom-badge-red',
    keyPoints: ['Harga Bisnis', 'Limit ditentukan KoinWorks', 'Tenor 30, 60, dan 90 hari']
  },
  CREDILINQ: {
    name: 'CrediLinq',
    badgeClass: 'custom-badge-square custom-badge-purple',
    keyPoints: ['Harga Bisnis', 'Limit ditentukan CrediLinq', 'Tenor 30, 60, dan 90 hari']
  },
  'MODAL RAKYAT': {
    name: 'Modal Rakyat',
    badgeClass: 'custom-badge-square custom-badge-yellow',
    keyPoints: []
  }
}

export function businessGradeOptionsFunc () {
  return Object.keys(businessGrade).map((item) => {
    return {
      label: businessGrade[item]?.name,
      value: item
    }
  })
}

export const businessGradeOptions = businessGradeOptionsFunc()

export const submissionStatus = {
  bnpl: {
    PROCESSED: {
      name: 'Diproses',
      badgeClass: 'custom-badge-yellow'
    },
    REJECTED: {
      name: 'Ditolak',
      badgeClass: 'custom-badge-red'
    },
    APPROVED: {
      name: 'Disetujui',
      badgeClass: 'custom-badge-green'
    }
  },
  jm: {
    SUBMITTED: {
      name: 'Menunggu',
      badgeClass: 'custom-badge-yellow'
    },
    REJECTED: {
      name: 'Ditolak',
      badgeClass: 'custom-badge-red'
    },
    APPROVED: {
      name: 'Disetujui',
      badgeClass: 'custom-badge-green'
    }
  }
}

export function submissionStatusOptionsFunc (type) {
  return Object.keys(submissionStatus[type]).map((item) => {
    return {
      label: submissionStatus[type][item]?.name,
      value: item
    }
  })
}

export const submissionBnplStatusOptions = submissionStatusOptionsFunc('bnpl')
export const submissionJmStatusOptions = submissionStatusOptionsFunc('jm')

export const submissionHighlightCta = function () {
  return {
    koinworks: {
      approved: {
        color: 'green',
        title: `Selamat, Kamu Mendapatkan Limit Rp ${digitGroup(this.dataDetail?.applicationDetail?.limitApproved) || '-'}`,
        desc: 'Customer sudah dapat melakukan transaksi dengan Pembayaran KoinWorks sesuai dengan limit yang diberikan',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          title: 'Lihat Customer'
        },
        clickCTA: () => {
          this.$router.push(`/customer/detail/preview/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}`)
        }
      },
      rejected: {
        color: 'red',
        title: 'Pengajuan Ditolak KoinWorks',
        desc: 'Alasan penolakan berada pada detail sebelah kanan!',
        icon: require('assets/images/icons/40x40-rejected.svg'),
        showButton: false
      },
      'uncomplete-document': {
        color: 'yellow',
        title: 'Dokumen Pengajuan Belum Lengkap',
        desc: 'Lengkapi dokumen pengajuan untuk melanjutkan proses pengajuan dengan menekan tombol disebelah kanan',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          title: 'Lengkapi Dokumen',
          icon: require('assets/images/icons/16x16-edit-white.svg')
        },
        clickCTA: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        }
      },
      'not-exist-limit': {
        color: 'yellow',
        title: 'Dokumen Pengajuan Belum Lengkap',
        desc: 'Lengkapi dokumen pengajuan untuk melanjutkan proses pengajuan dengan menekan tombol disebelah kanan',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          title: 'Lengkapi Dokumen',
          icon: require('assets/images/icons/16x16-edit-white.svg')
        },
        clickCTA: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        },
        showSubCta: true,
        subCta: {
          color: 'yellow',
          desc: 'Pengguna belum memasukan Limit Kredit yang diminta',
          icon: require('assets/images/icons/warning-16x16.svg'),
          showButton: false
        }
      },
      'complete-document': {
        color: 'green',
        title: 'Dokumen Sudah Lengkap!',
        desc: 'Silakan untuk meminta pengguna untuk melakukan pengajuan di webstite',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          title: 'Ubah Dokumen',
          icon: require('assets/images/icons/16x16-edit-white.svg')
        },
        clickCTA: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        }
      },
      'on-progress': {
        color: 'blue',
        title: 'Dokumen Sedang Ditinjau oleh Tim Koinworks',
        desc: 'Tunggu sejenak, Koinworks akan memberikan kabar apabila pengajuan telah diproses.',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        showButton: false
      },
      'waiting-for-otp': {
        color: 'blue',
        title: 'Menunggu Konfirmasi OTP Dari Customer',
        desc: 'Konfirmasi Kode OTP hanya bisa melalui website dan dilakukan oleh Customer',
        icon: require('assets/images/icons/timer.svg'),
        showButton: false
      },
      'final-step': {
        color: 'blue',
        title: 'Pengajuan Sedang Di Tahap Terakhir',
        desc: 'Tunggu sejenak, Koinworks akan memproses segera pengajuanmu!',
        icon: require('assets/images/icons/timer.svg'),
        showButton: false
      },
      'contract-document': {
        color: 'blue',
        title: 'Menunggu Dokumen Kontrak ',
        desc: 'Satu langkah lagi untuk mendapatkan limit kredit. Silakan beri kabar customer untuk mengunggah dokumen kontrak!',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          title: 'Unduh Template',
          icon: require('assets/images/icons/download-underscore.svg')
        },
        clickCTA: () => {
          const link = document.createElement('a')
          link.href = this.dataDetail?.templateContractDocument
          link.target = '_blank'
          link.setAttribute(
            'download',
            this.dataDetail?.templateContractDocument
          )
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        }
      }
    },
    credilinq: {
      // Need 2 button
      'send-data-consent': {
        color: 'blue',
        title: 'Menunggu Data Consent Costumer Dikirim',
        desc: 'Proses ini membutuhkan email perusahaan yang akan dikirimkan kepada CrediLinq',
        icon: require('assets/images/icons/timer.svg'),
        button: {
          icon: require('assets/images/icons/send-3.svg'),
          title: 'Kirim Data Consent'
        },
        clickCTA: () => {
          this.dialog.dataConsent.show = true
        },
        showButtonSub: true,
        buttonSub: {
          button: {
            title: 'Ubah Dokumen'
          }
        },
        clickCTASub: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        }
      },
      'data-consent-processed': {
        color: 'blue',
        title: 'Data Consent Sedang Diproses Oleh CrediLinq',
        desc: 'Silakan tunggu sejenak, Anda akan diberikan kabar jika pengajuan telah diproses ke tahap berikutnya!',
        icon: require('assets/images/icons/timer.svg'),
        button: {
          title: 'Ubah Dokumen'
        },
        clickCTA: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        }
      },
      'data-consent-rejected': {
        color: 'red',
        title: 'Pengajuan Kamu Ditolak CrediLinq',
        desc: 'Alasan penolakan berada pada detail sebelah kanan',
        icon: require('assets/images/icons/40x40-rejected.svg'),
        showButton: false
      },
      // Need 2 button
      'ready-to-submit': {
        color: 'yellow',
        title: 'Kirim Pengajuan Customer Ke CrediLinq',
        desc: 'Pastikan dokumen yang akan dikirimkan telah benar untuk menghindari proses pergantian dokumen',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          icon: require('assets/images/icons/send-3.svg'),
          title: 'Kirim Pengajuan'
        },
        clickCTA: () => {
          this.$router.push({
            name: 'customer-submission-credilinq-complete-address',
            params: { ...this.$route.params }
          })
        },
        showButtonSub: true,
        buttonSub: {
          button: {
            title: 'Ubah Dokumen'
          }
        },
        clickCTASub: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        }
      },
      'uncomplete-document': {
        color: 'yellow',
        title: 'Silakan Lengkapi Dokumen Untuk Melanjutkan Proses Pengajuan',
        desc: 'Pastikan dokumen yang akan dikirimkan telah benar untuk menghindari proses pergantian dokumen',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          title: 'Ubah Dokumen'
        },
        clickCTA: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        }
      },
      // Need 2 button
      'resend-submission': {
        color: 'red',
        title: 'Pengajuan Kamu Ditolak CrediLinq',
        desc: 'Silakan lihat alasan penolakan disebelah kanan',
        icon: require('assets/images/icons/40x40-rejected.svg'),
        button: {
          icon: require('assets/images/icons/send-3.svg'),
          title: 'Kirim Ulang Pengajuan'
        },
        clickCTA: () => {
          this.$router.push({
            name: 'customer-submission-credilinq-complete-address',
            params: { ...this.$route.params }
          })
        },
        showButtonSub: true,
        buttonSub: {
          button: {
            title: 'Ubah Dokumen'
          }
        },
        clickCTASub: () => {
          LocalStorage.set('filter:customer-detail-grade', [this.dataDetail?.gradeId])
          this.$router.push(`/customer/detail/edit/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}?gradeIdSubmission=${this.dataDetail?.gradeId}&bnplName=${this.bnplName}`)
        }
      },
      approved: {
        color: 'green',
        title: `Selamat, Kamu Mendapatkan Limit Rp ${digitGroup(this.dataDetail?.applicationDetail?.limitApproved) || '-'}`,
        desc: 'Customer sudah dapat melakukan transaksi dengan Pembayaran CrediLinq sesuai dengan limit yang diberikan',
        icon: require('assets/images/icons/40x40-empty-state.svg'),
        button: {
          title: 'Lihat Customer'
        },
        clickCTA: () => {
          this.$router.push(`/customer/detail/preview/${this.dataDetail?.customerId}/false/BUSINESS/${this.companyId}`)
        }
      },
      processed: {
        color: 'blue',
        title: 'Pengajuan Sedang Diproses Oleh CrediLinq',
        desc: 'Silakan tunggu sejenak, Anda akan diberikan kabar jika pengajuan telah diproses ke tahap berikutnya!',
        icon: require('assets/images/icons/timer.svg'),
        showButton: false
      },
      'final-process': {
        color: 'blue',
        title: 'Menunggu DocuSign Disetujui CrediLinq',
        desc: 'Silakan tunggu sejenak, Anda akan diberikan kabar jika pengajuan telah diproses ke tahap berikutnya!',
        icon: require('assets/images/icons/timer.svg'),
        showButton: false
      },
      'send-docusign': {
        color: 'yellow',
        title: 'Kirim Dokumen Perjanjian Kontrak Melalui DocuSign',
        desc: 'Selamat form dokumen pengajuan telah disetujui. Untuk melanjutkan proses selanjutnya, Anda harus menandatangani dokumen perjanjian yang akan dikirimkan ke email Anda.',
        icon: require('assets/images/icons/timer.svg'),
        button: {
          icon: require('assets/images/icons/send-3.svg'),
          title: 'Kirim DocuSign'
        },
        clickCTA: () => {
          this.sendAgreement()
        }
      }
    },

    // JURAGAN MODAL
    ...(() => {
      const arr = [
        {
          name: 'product-sales-manager',
          title: 'Product Sales Manager'
        },
        {
          name: 'fat-manager',
          title: 'Finance'
        },
        {
          name: 'senior-vp-sales',
          title: 'Sales SVP'
        }
      ]

      const result = arr.reduce((acc, { name, title }) => {
        acc[name] = {
          APPROVED: {
            color: 'green',
            title: `Horeee, Pengajuan Disetujui ${title}!`,
            desc: 'Pengajuan telah disetujui, customer dapat melakukan transaksi dengan metode pembayaran PayLater',
            icon: require('assets/images/icons/40x40-hand-shake.svg'),
            showButton: false
          },
          REJECTED: {
            color: 'red',
            title: `Pengajuan BNPL Kamu Ditolak ${title}`,
            desc: 'Jangan bersedih hati, kamu masih bisa melakukan pengajuan lagi, pastikan data yang kamu berikan sesuai ya!',
            icon: require('assets/images/icons/40x40-rejected.svg'),
            showButton: false
          },
          SUBMITTED: this.isEligibleToApproval === true
            ? {
                color: 'yellow',
                title: 'Konfirmasi Pengajuan',
                desc: 'Untuk memproses rekomendasi dari sales, silakan untuk ditinjau data-data yang diberikan terlebih dahulu',
                icon: require('assets/images/icons/40x40-empty-state.svg'),
                showButton: true,
                showButtonSub: true,
                button: {
                  title: 'Terima'
                },
                buttonSub: {
                  button: {
                    title: 'Tolak',
                    vbind: 'btnDeleteOk'
                  }
                },
                clickCTA: () => {
                  this.onClickSubmissionConfirm('approve')
                },
                clickCTASub: () => {
                  this.onClickSubmissionConfirm('reject')
                }
              }
            : {
                color: 'blue',
                title: `Sedang Menunggu Persetujuan Oleh ${title}`,
                desc: 'Silakan untuk ditunggu, Anda akan mendapat pemberitahuan melalui Email apabila pengajuan telah ditinjau',
                icon: require('assets/images/icons/timer.svg'),
                showButton: false
              }
        }

        return acc
      }, {})

      return result
    })()
  }
}

export const userTypeOptions = [
  {
    label: 'Bisnis',
    value: 'BUSINESS'
  },
  {
    label: 'Retail',
    value: 'RETAIL'
  }
]

export const companyTypeOptions = [
  {
    label: 'PT',
    value: 'PT'
  },
  {
    label: 'CV',
    value: 'CV'
  },
  {
    label: 'UD',
    value: 'UD'
  },
  {
    label: 'TB',
    value: 'TB'
  },
  {
    label: 'Firma',
    value: 'FIRMA'
  },
  {
    label: 'Lainnya',
    value: 'OTHER'
  }
]

export const customerCompanyTypeOptions = [
  {
    label: 'Pemilik Proyek',
    value: 'PROJECT_OWNER'
  },
  {
    label: 'Arsitek',
    value: 'ARCHITECT'
  },
  {
    label: 'Developer',
    value: 'DEVELOPER'
  },
  {
    label: 'Kontraktor',
    value: 'CONTRACTOR'
  },
  {
    label: 'Lainnya',
    value: 'OTHER'
  }
]
